/* bgl-cta-gaps.js - Bigoli Fresh Pasta. GA4 cta_click gap fill.
 *
 * WHY. The live snippet bgl-meta-events sends cta_click for links that carry
 * data-bgl-cta. Several order-intent links on the site carry no attribute
 * (catering call/email, links into the catering page), so their taps are
 * invisible per button. This file sends the SAME event, cta_click, for those
 * untagged links only, with cta_source:'auto' so they can be told apart.
 *
 * WHAT IT NEVER DOES
 *  - never fires on a link that has data-bgl-cta (no double counting);
 *  - never sends href, phone number, email address, link text or form data;
 *  - never sends value/currency: a click is not a sale;
 *  - never touches consent: gtag applies the Consent Mode state set by
 *    snippets/bgl-measurement.liquid from Shopify.customerPrivacy;
 *  - never throws into the page.
 *
 * Spec: growth/measurement/outputs/CTA-TRACKING-SPEC-2026-10-08.md
 * Rollback: delete the one include line in layout/theme.liquid.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) { return; }
  if (window.__bglCtaGaps) { return; }
  window.__bglCtaGaps = true;

  var ACTION_SELECTOR = 'a[href]';

  function lower(s) { return String(s || '').toLowerCase(); }

  function isMaps(host, path, href) {
    if (host === 'maps.app.goo.gl' || host.indexOf('maps.google.') === 0) { return true; }
    if (host === 'goo.gl' && path.indexOf('/maps') === 0) { return true; }
    if (/(^|\.)google\.[a-z.]+$/.test(host) && path.indexOf('/maps') === 0) { return true; }
    return /^geo:/.test(href);
  }

  function classify(a) {
    var href = lower(a.getAttribute('href')).replace(/^\s+/, '');
    var path = lower(window.location.pathname);

    if (href.indexOf('tel:') === 0) { return 'call'; }

    if (href.indexOf('mailto:') === 0) {
      var q = '';
      try { q = decodeURIComponent(href.split('?')[1] || ''); } catch (e) { q = href; }
      if (path.indexOf('catering') > -1 || /catering|pre-?order/.test(q)) {
        return 'catering_enquiry';
      }
      return 'email';
    }

    if (href.charAt(0) === '#') { return null; }      /* in-page jump, not an action */

    var host = lower(a.hostname).replace(/^www\./, '');
    var lpath = lower(a.pathname);
    if (!host) { return null; }

    if (isMaps(host, lpath, href)) {
      return (lpath.indexOf('/dir') > -1 || href.indexOf('destination=') > -1) ? 'directions' : 'address';
    }
    if (host === 'deliveroo.co.uk' || /\.deliveroo\.co\.uk$/.test(host) || host === 'deliveroo.com') {
      return 'deliveroo';
    }
    if (host === 'ubereats.com' || /\.ubereats\.com$/.test(host)) { return 'ubereats'; }

    if (host === lower(window.location.hostname).replace(/^www\./, '') &&
        lpath.replace(/\/+$/, '') === '/pages/corporate-catering') {
      return 'catering_page';
    }
    return null;
  }

  /* Placement = the Shopify section the link sits in, e.g.
     "shopify-section-template--123__catering_form" -> "catering_form",
     "shopify-section-sections--456__header"        -> "header".
     Section names are theme identifiers, never visitor data. */
  function placement(a) {
    var sec = a.closest('[id^="shopify-section-"]');
    if (!sec) { return 'other'; }
    var id = String(sec.id || '');
    var i = id.lastIndexOf('__');
    var name = i > -1 ? id.slice(i + 2) : id.replace('shopify-section-', '');
    name = lower(name).replace(/[^a-z0-9_]/g, '_').slice(0, 40);
    return name || 'other';
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') { return; }
      var a = t.closest(ACTION_SELECTOR);
      if (!a) { return; }
      if (a.closest('[data-bgl-cta]')) { return; }   /* already measured by bgl-meta-events */

      var type = classify(a);
      if (!type) { return; }

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'cta_click', {
          link_type: type,
          placement: placement(a),
          cta_source: 'auto'
        });
      }
    } catch (err) {
      /* Analytics is never worth breaking a page over. */
    }
  }, true);
}());
